module.exports = __webpack_public_path__ + "img/202M.ec02dde2.png";